import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import { AuthService } from '../service/auth.service';
import { CommonService } from '../service/common.service';

import { version } from '../../version';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
})
export class SidebarComponent implements OnInit {
  constructor(
    private router: Router,
    private commonService: CommonService,
    private authService: AuthService
  ) {
    this.showUserManagement = false;
    // THIS ARRAY IS TO ACTIVE SELECTED LINK
    this.allSideMenu = [
      { text: 'Home', path: '/home', parent: [1, 2, 3, 4, 5, 6, 7] },
      { text: 'Project Data', path: '/projectdata', parent: [1, 2, 3, 4, 5, 6, 7] },
      { text: 'Budget', path: '/budget', parent: [1, 2, 3, 4, 5, 6, 7] },
      { text: 'RAL Financing & Investment', path: '/', parent: [1, 2, 3, 4, 5, 6, 7] },
      { text: 'Operating Expenses', path: '/operating_expenses', parent: [1, 2, 3, 4, 5, 6, 7] },
      { text: 'Cash Flow', path: '/', parent: [1, 2, 3, 4, 5, 6, 7] },
      { text: 'RAL Enterprise Appraisal&trade', path: '/', parent: [1, 2, 3, 4, 5, 6, 7] },
      { text: 'Financial Analysis', path: '/', parent: [1, 2, 3, 4, 5, 6, 7] },
      { text: 'Recast / Comparison', path: '/', parent: [1, 2, 3, 4, 5, 6, 7] },
      { text: 'Loan Schedules', path: '/', parent: [1, 2, 3, 4, 5, 6, 7] },
      { text: 'Summary', path: '/', parent: [1, 2, 3, 4, 5, 6, 7] },
      { text: 'Presentation / Printing', path: '/', parent: [1, 2, 3, 4, 5, 6, 7] },
      { text: 'UserManagement', path: '/', parent: [1, 2, 3, 4, 5, 6, 7] },
      { text: 'Tutorials', path: '/', parent: [1, 2, 3, 4, 5, 6, 7] },
      { text: 'Instructions', path: '/', parent: [1, 2, 3, 4, 5, 6, 7] },
      { text: 'Glossary', path: '/', parent: [1, 2, 3, 4, 5, 6, 7] },
      { text: 'corporate', path: '/', parent: [1, 2, 3, 4, 5, 6, 7] },
    ];
    this.getUserInfo();
  }

  // DECLARATION OF ALL VARIABLES
  public sideMenu: any = [];

  public allSideMenu: any;

  private subscription: Subscription;

  public parent: number;

  projectId: string;

  showUserManagement: boolean;

  version: string;

  ngOnInit() {
    this.version = version;

    if (localStorage.getItem('select-page') !== undefined) {
      this.parent = JSON.parse(localStorage.getItem('select-page'));
      this.selectSildeMenu();
    } else {
      this.parent = 1;
      this.selectSildeMenu();
    }

    this.subscription = this.commonService.notifyObservable$.subscribe((res) => {
      if (res.hasOwnProperty('option') && res.option === 'select-page') {
        this.parent = res.value;
        this.selectSildeMenu();
      }
    });
  }

  // EXECUTE WHEN NONE OF PROJECT IS SELECTED IN HOME PAGE, USER HAVE TO SELECT ONE PROJECT
  check() {
    this.projectId = JSON.parse(JSON.stringify(localStorage.getItem('projectId') || null));
    if (undefined === this.projectId || this.projectId === null) {
      alert('Please select any project.');
    }
  }

  // THIS IS TO SET SELECTED PAGE INTO LOCAL STORAGE, TO ACTIVE THAT LINK
  private selectSildeMenu() {
    localStorage.setItem('select-page', JSON.stringify(this.parent));
    this.sideMenu = [];
    for (let i = 0; i < this.allSideMenu.length; i++) {
      if (this.allSideMenu[i].parent.indexOf(this.parent) > -1) {
        this.sideMenu.push(this.allSideMenu[i]);
      }
    }
  }

  // TO GET KNOW THAT USER THAT LOGGED IN IS ADMIN OR NOT
  getUserInfo() {
    this.authService.isAdmin().subscribe((response) => {
      // console.log("auth admin response: ",response);
      if (response === true) {
        this.showUserManagement = true;
      } else {
        this.showUserManagement = false;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/sidebar/sidebar.component.ts